"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Other = void 0;
var react_1 = __importDefault(require("react"));
var dog_png_1 = __importDefault(require("../../assets/dog.png"));
var react_bootstrap_1 = require("react-bootstrap");
var __1 = require("../..");
var react_router_1 = require("react-router");
var Other = function () {
    var siteConfig = (0, __1.useEloise)().siteConfig;
    var bugReporting = true; //todo replace with siteConfig field
    var navigate = (0, react_router_1.useNavigate)();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, { lg: 6, className: "mx-auto mt-4" },
                react_1.default.createElement(__1.View, { style: { flexDirection: "column" } },
                    react_1.default.createElement(__1.Heading, { color: "black", size: 4 }, "Something went wrong..."),
                    react_1.default.createElement(__1.Heading, { color: "black", size: 4 }, "You weren't supposed to see this.")),
                react_1.default.createElement("div", { className: "mt-3 row" },
                    react_1.default.createElement(react_bootstrap_1.Col, { lg: 5, className: "mx-auto" },
                        react_1.default.createElement(__1.Button, { onClick: function () { return navigate("/"); } }, "Return Home")),
                    bugReporting && (react_1.default.createElement(react_bootstrap_1.Col, { lg: 5, className: "mx-auto" },
                        react_1.default.createElement(__1.Button, { onClick: function () { return navigate("/report-bug"); } }, "Report Bug")))))),
        react_1.default.createElement(react_bootstrap_1.Row, { className: "mx-auto", style: { position: "fixed", bottom: "0", width: "100%" } },
            react_1.default.createElement(react_bootstrap_1.Col, { lg: 6, className: "mx-auto text-center" },
                react_1.default.createElement("img", { src: String(dog_png_1.default), height: "200" })))));
};
exports.Other = Other;
